import styled from "styled-components/macro";

export const WrapperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  & .aboutStudent {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & .header {
    color: ${(props) => props.theme.colors.text};
    font-size: 18px;
    font-weight: 600;
    line-height: 133%;
  }
  .main {
    margin-top: 1rem;
    display: flex;
    img {
      margin-right: 1.5rem;
      width: 200px;
      height: 200px;
      object-fit: cover;
    }

    @media ${(props) => props.theme.media.phone} {
      flex-wrap: wrap;
      img {
        width: 100%;
        margin-bottom: 1rem;
      }
    }
  }
  hr {
    margin-top: 1rem;
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid ${(props) => props.theme.colors.border};
  }
  .footer {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    .dates {
      display: flex;
      align-items: center;
      & > svg {
        margin-right: 8px;
      }
    }
    .buttons {
      display: flex;
      button {
        margin-left: 10px;
      }
    }
    @media ${(props) => props.theme.media.phone} {
      flex-direction: column;
      width: 100%;
      .buttons {
        flex-direction: column;
        button {
          margin-top: 1rem;
          width: 100%;
          margin-left: 0;
        }
      }
    }
  }
`;


export const DialogInnerDiv = styled.div`
  margin: 1rem;
  & .cal {
    overflow: auto;
    position: relative;
  }
  & > h2 {
    align-self: flex-start;
    padding-right: 1em;
  }
  & > h4 {
    margin: 6px 0 8px 0;
  }
`;
